import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('ROUTER', {
  LOCATION_CHANGED: null,
  ROUTER_TRANSITION: null
});



// WEBPACK FOOTER //
// ./app/constants/RouterConstants.js